import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import FontAwesome from 'react-fontawesome';
import { Header, AddButton, HubSidebar } from '../../components';
import { validateAccess } from '../../session';
import { pollsLoaded, setAuth } from '../../actions';
import { feedbackActions } from '../../webapi';
import { COLOUR_BRANDING_OFF } from '../../js';
import Polls from './Polls';

class PollsHub extends Component {
  state = {
    selectedSection: 'all',
    location: '',

    loadingPolls: false,

    polls: [],
    currentPolls: [],
    pastPolls: [],
    now: moment.utc().valueOf(),
  };

  UNSAFE_componentWillMount() {
    this.updateProps(this.props);

    this.loadPolls();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.updateProps(nextProps);
  }

  updateProps(props) {
    const polls = [];

    props.polls.forEach((ev) => {
      if (ev != null && !ev.Deleted) {
        polls.push(ev);
      }
    });

    const currentPolls = _.filter(polls, (ev) => {
      return this.state.now > ev.StartTime && this.state.now < ev.EndTime;
    });

    const pastPolls = _.filter(polls, (ev) => {
      return this.state.now > ev.EndTime;
    });

    this.setState({ polls, currentPolls, pastPolls });
  }

  loadPolls() {
    this.setState({
      loadingPolls: true,
    });

    feedbackActions
      .getPolls(this.props.auth.site)
      .then((res) => {
        this.setState({
          loadingPolls: false,
        });
        if (res.data != null && !_.isEmpty(res.data) && res.data[0].Site === this.props.auth.site) {
          this.props.pollsLoaded(res.data);
        }
      })
      .catch((res) => {
        this.setState({ loadingPolls: false });
        alert('Something went wrong with the request. Please try again.');
      });
  }

  addNew = () => {
    if (this.canAddNew()) {
      this.props.history.push(`/polls/poll`);
    }
  };

  addNewPoll = () => {
    if (this.canAddNew()) {
      this.props.history.push(`/polls/livepoll`);
    }
  };

  canAddNew(isClass) {
    if (validateAccess(this.props.auth.site, 'polls', this.props.auth)) {
      return isClass ? '' : true;
    }
    return isClass ? ' hub-sideContent-topButton--hide' : false;
  }

  getSideBarSectionColour(id) {
    return this.state.selectedSection === id ? { backgroundColor: '#fff' } : {};
  }

  renderStats(component, loading) {
    if (loading) {
      return <FontAwesome style={styles.spinner} name="spinner fa-pulse fa-fw" />;
    }
    return component;
  }

  renderLeftBar() {
    const sectionItems = [];

    if (this.canAddNew()) {
      sectionItems.push({
        type: 'newButton',
        text: 'New Survey',
        onClick: this.addNew,
      });
    }

    sectionItems.push({
      type: 'navItem',
      text: 'View Surveys',
      icon: 'eye',
      isFontAwesome: true,
      selected: this.state.selectedSection === 'all',
      onClick: () => {
        this.setState({ selectedSection: 'all' });
      },
    });
    const pollItems = [];

    if (this.canAddNew()) {
      pollItems.push({
        type: 'newButton',
        text: 'New Live Poll',
        onClick: this.addNewPoll,
      });
    }

    pollItems.push({
      type: 'navItem',
      text: 'View Live Polls',
      icon: 'eye',
      isFontAwesome: true,
      selected: this.state.selectedSection === 'livePolls',
      onClick: () => {
        this.setState({ selectedSection: 'livePolls' });
      },
    });

    return (
      <HubSidebar
        sections={[
          {
            title: 'Surveys',
            items: sectionItems,
          },
          {
            title: 'Live Polls',
            items: pollItems,
          },
        ]}
      />
    );
  }

  render() {
    return (
      <div className="hub-wrapperContainer">
        {this.renderLeftBar()}
        <div className="hub-headerContentWrapper">
          <Header />
          <div className="hub-contentWrapper">
            <Polls filterOption={this.state.selectedSection} />
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  sideBarTitleSection: {
    lineHeight: '50px',
    marginTop: 30,
    marginBottom: 30,
    paddingLeft: 24,
  },
  sideBarSection: {
    weight: '100%',
    minWidth: 200,
    padding: 32,
    paddingLeft: 24,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  spinner: {
    fontSize: 32,
    color: COLOUR_BRANDING_OFF,
  },
};

const mapStateToProps = (state) => {
  const { polls } = state.feedback;
  const { auth } = state;
  return {
    polls,
    auth,
  };
};

export default connect(mapStateToProps, { pollsLoaded, setAuth })(PollsHub);
